export default {
      id: "filter-usage",
      viewBox: "0 0 15 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#filter",
      toString: function () {
        return this.url;
      }
    }